import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { api } from '../../../core/network/api';
import { birthKeys } from '../queries/keys';
import { birthPaths } from '../queries/paths';

// TSS vite/03 — nacimientos (admin-births.md): lista + alta de parto + edición del
// ciclo de registro de la cría (registration_ticket / registration, tras el parto).

export function useBirthsList(filters) {
    return useQuery({
        queryKey: birthKeys.list(filters),
        queryFn:  ({ signal }) => api.get(birthPaths.list(), { params: filters, signal }).then(r => r.data),
        placeholderData: (prev) => prev,
    });
}

// PATCH del birth para el ciclo de registro (registration_ticket + fecha, registration
// número). Devuelve el birth ensamblado; invalida la lista de nacimientos.
export function useUpdateBirth(id) {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (payload) => api.patch(birthPaths.detail(id), payload).then(r => r.data),
        onSuccess:  () => qc.invalidateQueries({ queryKey: birthKeys.all }),
    });
}

// TSS vite/03 — alta de parto (admin-births.md). Compuesto/atómico: crea cría +
// nacimiento + genealogía y pasa la preñez a `born`. Tras crearlo, la preñez sale de
// la lista de confirmadas → se invalidan preñeces, sesiones TE de la OPU y KPIs.
export function useCreateBirth() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (payload) => api.post(birthPaths.list(), payload).then(r => r.data),
        onSuccess: () => {
            qc.invalidateQueries({ queryKey: birthKeys.all });
            qc.invalidateQueries({ queryKey: ['pregnancies'] });
            qc.invalidateQueries({ queryKey: ['transfer-sessions'] });
            qc.invalidateQueries({ queryKey: ['opu'] });
            qc.invalidateQueries({ queryKey: ['kpis'] });
        },
    });
}
